import React from 'react';

import {
  DefaultOptionType,
  SelectProps as AntdSelectProps,
} from 'antd/lib/select';

import { JuridictionAdminResponseDtoTypeEnum } from 'lib_api/lib/api/gen';

import BaseSelect from 'components/BaseForm/Select/BaseSelect';
import { typeJuridictionMapping } from 'utils/enumData';

export default function BaseSelectTypeJuridiction(props: AntdSelectProps) {
  const options: DefaultOptionType[] = Object.keys(
    JuridictionAdminResponseDtoTypeEnum,
  ).map(key => ({
    label: typeJuridictionMapping[key as JuridictionAdminResponseDtoTypeEnum],
    value: key,
  }));

  return (
    <BaseSelect
      options={options}
      getOptionValue={option => option.value as string}
      getOptionLabel={option => option.label}
      {...props}
    />
  );
}
